import { ExperimentsGroup } from '@superbet-group/product.analytics';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import { differenceInDays } from '@superbet-group/web.lib.utilities';
import authStore from '@store/modules/data/authentication/authenticationIndex';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';

let whichPe131Variant : ExperimentsGroup = ExperimentsGroup.None;
let hasCheckedCriteria = false;
let isPe131CriteriaFulfilled = false;

function processPe131Criteria(): ExperimentsGroup {
    const authModule = useVuexStore<typeof authStore>('data/authentication');
    const authenticatedUser = authModule.getter('user');
    // can't check for unauthenticated users
    if (!authenticatedUser.value) {
        return ExperimentsGroup.None;
    }
    if (whichPe131Variant === ExperimentsGroup.None) {
        // If the flag is off, the criteria fails, no need to check user details
        return ExperimentsGroup.None;
    }
    hasCheckedCriteria = true; // prevent checking again to reduce overhead and to preserve the behaviour

    const hasMadeDeposit = !!authenticatedUser.value?.hasMadeDeposit;
    const isUserRegisteredForLessThan30Days = differenceInDays(new Date(), authenticatedUser.value.registrationDate) <= 30;

    if (hasMadeDeposit && isUserRegisteredForLessThan30Days) {
        isPe131CriteriaFulfilled = true;
        AnalyticsSDK.getInstance().log('Pe131_Descriptive_Odd_Button_Shown', { variant: whichPe131Variant });
        if (whichPe131Variant !== ExperimentsGroup.A) {
            return whichPe131Variant;
        }
    }
    return ExperimentsGroup.None;
}

export function getPe131DescriptiveOddButtonVariant(): ExperimentsGroup {
    if (hasCheckedCriteria) {
        if (!isPe131CriteriaFulfilled || whichPe131Variant === ExperimentsGroup.A) {
            return ExperimentsGroup.None;
        }
        return whichPe131Variant;
    }
    return processPe131Criteria();
}

export function setPe131DescriptiveOddButtonVariant(value: ExperimentsGroup): void {
    whichPe131Variant = value;
}
